import React,{useState} from "react";

import {
  FiTruck,
  FiPackage,
  FiBell,
  FiClock
} from "react-icons/fi";

import { FiMessageCircle } from "react-icons/fi";

export default function CustomerDashboard({
  user,
  currentTime,
  activeOrders,
  completedOrders,
  orders,
  notifications,
  setActiveSection
}) {

const [chatbotOpen,setChatbotOpen] =
  useState(false);

const [chatbotMessages,setChatbotMessages] =
  useState([
    {
      sender:"bot",
      text:"Hi 👋 I am MB Swift Assistant. How can I help you today?"
    }
  ]);

const [chatbotText,setChatbotText] =
  useState(""); 
  
function sendChatbotMessage(){

  if(!chatbotText.trim()){
    return;
  }

  const userMessage =
    chatbotText.trim();

  const text =
    userMessage.toLowerCase();

  let botReply =
    "I can help with orders, riders, payment, cancellation, support, and delivery tracking.";

  if(text.includes("hi") || text.includes("hello")){
    botReply =
      "Hi 👋 I am MB Swift Assistant. How can I help you today?";
  }

  else if(text.includes("thank")){
    botReply =
      "You're welcome 😊";
  }

  else if(text.includes("rider")){
    botReply =
      "Once a rider accepts your order, you can see their photo, name, phone number, chat button, and live location on your order page.";
  }

  else if(text.includes("cancel")){
    botReply =
      "You can cancel an order while it is still pending before a rider accepts it.";
  }

  else if(text.includes("pay") || text.includes("momo")){
    botReply =
      "You can pay with Cash on Delivery or Mobile Money when available.";
  }

  else if(text.includes("track") || text.includes("where")){
    botReply =
      "Go to Orders to track your delivery. You will see pickup, dropoff, rider details, and live map.";
  }

  else if(text.includes("support") || text.includes("help")){
    botReply =
      "Go to Messages or Contact Us to reach MB Swift support.";
  }

  setChatbotMessages([
    ...chatbotMessages,
    {
      sender:"user",
      text:userMessage
    },
    {
      sender:"bot",
      text:botReply
    }
  ]);

  setChatbotText("");
} 

function copyReferralCode(){

  const code =
    user?.referralCode || "";

  if(!code){
    alert("Referral code not available yet");
    return;
  }

  navigator.clipboard.writeText(code);

  alert("Referral code copied");
}

function shareReferralCode(){

  const code =
    user?.referralCode || "";

  if(!code){
    alert("Referral code not available yet");
    return;
  }

  const message =
    `🚀 Get fast delivery with MB Swift.

Use my referral code:

${code}

https://www.mbswiftgh.com`;

  if(navigator.share){

    navigator.share({
      title:"MB Swift Referral",
      text:message,
      url:"https://www.mbswiftgh.com"
    });

    return;
  }

  navigator.clipboard.writeText(message);

  alert("Referral message copied");
}

  const [customerPage,setCustomerPage] =
    useState("home");

  const isMobile =
    window.innerWidth <= 768;

  const pendingOrders =
    orders.filter((o)=>o.status === "pending");

  function getPageTitle(){

    if(customerPage === "activeOrders"){
      return "Active Orders";
    }

    if(customerPage === "completedOrders"){
      return "Completed Orders";
    }

    if(customerPage === "notifications"){
      return "Notifications";
    }

    if(customerPage === "pendingOrders"){
      return "Pending Orders";
    }

    return "";
  }

  function getPageOrders(){

    if(customerPage === "activeOrders"){
      return activeOrders;
    }

    if(customerPage === "completedOrders"){
      return completedOrders;
    }

    if(customerPage === "pendingOrders"){
      return pendingOrders;
    }

    return [];
  }

  return (
    <>
      <div
        style={{
          position:"relative",
          overflow:"hidden",
          background:
            "radial-gradient(circle at top right, rgba(250,204,21,0.28), transparent 30%), linear-gradient(135deg,#0f172a,#1d4ed8)",
          color:"white",
          borderRadius:isMobile ? "20px" : "22px",
          padding:isMobile ? "12px" : "14px",
          marginBottom:"12px",
          boxShadow:"0 12px 28px rgba(15,23,42,0.14)"
        }}
      >
        <div
          style={{
            display:"grid",
            gridTemplateColumns:isMobile ? "1fr" : "minmax(0,1fr) 320px",
            gap:isMobile ? "22px" : "18px",
            alignItems:"center"
          }}
        >
          <div
            style={{
              display:isMobile ? "block" : "flex",
              alignItems:"center",
              gap:"16px",
              minWidth:0,
              textAlign:isMobile ? "center" : "left"
            }}
          >
            <img
              src="/logo.png"
              alt="MB Swift Logo"
              style={{
                width:isMobile ? "60px" : "58px",
                height:isMobile ? "60px" : "58px",
                objectFit:"contain",
                background:"white",
                padding:"6px",
                borderRadius:"50%",
                boxShadow:"0 10px 22px rgba(15,23,42,0.22)",
                margin:isMobile ? "0 auto 16px" : "0",
                display:"block",
                flexShrink:0
              }}
            />

            <div style={{minWidth:0}}>
              <div
                style={{
                  display:"inline-flex",
                  alignItems:"center",
                  justifyContent:"center",
                  background:"rgba(255,255,255,0.15)",
                  border:"1px solid rgba(255,255,255,0.25)",
                  color:"white",
                  padding:"8px 12px",
                  borderRadius:"999px",
                  fontSize:"12px",
                  fontWeight:"900",
                  marginBottom:"14px",
                  maxWidth:"100%"
                }}
              >
                ⚡ MB Swift Customer Dashboard
              </div>

              <h1
                style={{
                  fontSize:isMobile ? "22px" : "24px",
                  fontWeight:"900",
                  margin:"0 0 8px",
                  lineHeight:"1.08",
                  color:"white"
                }}
              >
                Welcome/Akwaaba,
                <br />
                {user?.name || "Customer"} 👋
              </h1>

              <p
                style={{
                  maxWidth:isMobile ? "100%" : "460px",
                  color:"#dbeafe",
                  fontSize:"12px",
                  lineHeight:"1.45",
                  margin:isMobile ? "0 auto" : "0",
                  fontWeight:"600"
                }}
              >
                Book deliveries, track riders, monitor payments,
                and manage every package from one clean dashboard.
              </p>

              <div
                style={{
                  display:"flex",
                  gap:"8px",
                  flexWrap:"wrap",
                  marginTop:"22px",
                  justifyContent:isMobile ? "center" : "flex-start"
                }}
              >
                <button
                  type="button"
                  onClick={() => setActiveSection("createOrder")}
                  style={{
                    border:"none",
                    borderRadius:"16px",
                    padding:"14px 18px",
                    background:"#facc15",
                    color:"#111827",
                    fontSize:"15px",
                    fontWeight:"900",
                    cursor:"pointer",
                    minWidth:isMobile ? "170px" : "auto"
                  }}
                >
                  Create New Delivery
                </button>

                <button
                  type="button"
                  onClick={() => setActiveSection("orders")}
                  style={{
                    border:"1px solid rgba(255,255,255,0.24)",
                    borderRadius:"16px",
                    padding:"10px 14px",
                    background:"rgba(255,255,255,0.14)",
                    color:"white",
                    fontSize:"13px",
                    fontWeight:"900",
                    cursor:"pointer",
                    minWidth:isMobile ? "170px" : "auto"
                  }}
                >
                  Track My Orders
                </button>
              </div>
            </div>
          </div>

          <div
            style={{
              width:"100%",
              maxWidth:isMobile ? "100%" : "260px",
              background:
                "linear-gradient(135deg,rgba(255,255,255,0.24),rgba(255,255,255,0.08))",
              border:"1px solid rgba(255,255,255,0.34)",
              borderRadius:"22px",
              padding:"14px",
              color:"white",
              boxShadow:"0 14px 30px rgba(0,0,0,0.18)",
              justifySelf:isMobile ? "stretch" : "end",
              textAlign:isMobile ? "center" : "left"
            }}
          >
            <div
              style={{
                color:"#bfdbfe",
                fontSize:"13px",
                fontWeight:"900",
                marginBottom:"8px"
              }}
            >
              Today
            </div>

            <div
              style={{
                fontSize:isMobile ? "18px" : "18px",
                fontWeight:"900",
                lineHeight:"1.15",
                marginBottom:"12px"
              }}
            >
              {currentTime.toLocaleDateString("en-US", {
                weekday:"short",
                month:"long",
                day:"numeric",
                year:"numeric"
              })}
            </div>

            <div
              style={{
                display:"inline-flex",
                padding:"6px 12px",
                marginBottom:"10px",
                borderRadius:"999px",
                background:"linear-gradient(135deg,#facc15,#f59e0b)",
                color:"#0f172a",
                fontSize:"13px",
                fontWeight:"900",
                letterSpacing:"1px"
              }}
            >
              {currentTime.toLocaleTimeString("en-US", {
                hour:"2-digit",
                minute:"2-digit",
                second:"2-digit"
              })}
            </div>

            <div
              style={{
                color:"#dbeafe",
                fontSize:"13px",
                marginTop:"8px",
                fontWeight:"700"
              }}
            >
              Ready to move your next package.
            </div>
          </div>
        </div>
      </div>

    <div
  style={{
    background:"linear-gradient(135deg,#0f172a,#1d4ed8)",
    borderRadius:"18px",
    padding:isMobile ? "14px" : "16px",
    color:"white",
    marginBottom:"14px",
    boxShadow:"0 8px 20px rgba(15,23,42,0.12)"
  }}
>
  <div
    style={{
      fontSize:isMobile ? "16px" : "18px",
      fontWeight:"900",
      color:"#facc15",
      marginBottom:"6px"
    }}
  >
    🚀 Fast Delivery Across Accra
  </div>

  <div
    style={{
      fontSize:"12px",
      fontWeight:"700",
      lineHeight:"1.45",
      marginBottom:"10px",
      color:"rgba(255,255,255,0.86)"
    }}
  >
    Book trusted riders for fast, secure and affordable deliveries.
  </div>

  <div
    style={{
      display:"flex",
      flexWrap:"wrap",
      gap:"6px",
      marginBottom:"10px"
    }}
  >
    {[
      "Same Day",
      "Live Tracking",
      "Secure"
    ].map((item)=>(
      <span
        key={item}
        style={{
          background:"rgba(250,204,21,0.18)",
          color:"#facc15",
          padding:"6px 9px",
          borderRadius:"999px",
          fontSize:"11px",
          fontWeight:"900"
        }}
      >
        {item}
      </span>
    ))}
  </div>

  <button
    type="button"
    onClick={() => setActiveSection("createOrder")}
    style={{
      width:"100%",
      border:"none",
      borderRadius:"14px",
      padding:"11px",
      background:"#facc15",
      color:"#0f172a",
      fontSize:"14px",
      fontWeight:"900",
      cursor:"pointer",
      transition:"0.2s ease"
    }}
  onMouseEnter={(e)=>{
  e.currentTarget.style.transform =
    "translateY(-2px)";
}}
onMouseLeave={(e)=>{
  e.currentTarget.style.transform =
    "translateY(0)";
}} 
  >
    Book Delivery Now
  </button>
</div>  

      {customerPage === "home" && (

  <div
    style={{
      background:"linear-gradient(135deg,#0f172a,#1d4ed8)",
      borderRadius:"18px",
      padding:isMobile ? "12px" : "14px",
      color:"white",
      marginBottom:"14px",
      boxShadow:"0 8px 20px rgba(29,78,216,0.14)"
    }}
  >
    <div
      style={{
        display:"flex",
        alignItems:"center",
        justifyContent:"space-between",
        gap:"10px",
        flexWrap:"wrap"
      }}
    >
      <div>
        <div
          style={{
            fontSize:isMobile ? "16px" : "18px",
            fontWeight:"900",
            marginBottom:"4px"
          }}
        >
          🎁 Refer & Earn
        </div>

        <div
          style={{
            fontSize:"12px",
            color:"rgba(255,255,255,0.82)",
            fontWeight:"700"
          }}
        >
          Share your code and earn rewards.
        </div>
      </div>

      <div
        style={{
          background:"rgba(255,255,255,0.12)",
          border:"1px solid rgba(250,204,21,0.30)",
          borderRadius:"14px",
          padding:"9px 12px",
          minWidth:isMobile ? "100%" : "260px"
        }}
      >
        <div
          style={{
            fontSize:"10px",
            fontWeight:"900",
            color:"#facc15",
            marginBottom:"3px"
          }}
        >
          YOUR CODE
        </div>

        <div
          style={{
            fontSize:isMobile ? "19px" : "22px",
            fontWeight:"900",
            letterSpacing:"1px"
          }}
        >
          {user?.referralCode || "MBSWIFT-----"}
        </div>
      </div>
    </div>

    <div
      style={{
        display:"flex",
        gap:"8px",
        flexWrap:"wrap",
        marginTop:"10px"
      }}
    >
      <button
        type="button"
        onClick={copyReferralCode}
        style={{
          border:"none",
          borderRadius:"12px",
          padding:"9px 12px",
          background:"#facc15",
          color:"#0f172a",
          fontSize:"12px",
          fontWeight:"900",
          cursor:"pointer"
        }}
      >
        Copy
      </button>

      <button
        type="button"
        onClick={shareReferralCode}
        style={{
          border:"1px solid rgba(255,255,255,0.25)",
          borderRadius:"12px",
          padding:"9px 12px",
          background:"rgba(255,255,255,0.12)",
          color:"white",
          fontSize:"12px",
          fontWeight:"900",
          cursor:"pointer"
        }}
      >
        Share
      </button>

      <div
        style={{
          padding:"9px 12px",
          borderRadius:"12px",
          background:"rgba(255,255,255,0.10)",
          color:"#facc15",
          fontSize:"12px",
          fontWeight:"900"
        }}
      >
        Credits: ₵{user?.referralCredits || 0}
      </div>
    </div>
  </div>

)}

      {customerPage === "home" && (
        <div
          style={{
            display:"grid",
            gridTemplateColumns:isMobile
              ? "repeat(2,minmax(0,1fr))"
              : "repeat(auto-fit,minmax(190px,1fr))",
            gap:"12px",
            marginBottom:"20px"
          }}
        >

          
          <StatCard
            title="Active Orders"
            value={activeOrders.length}
            icon={<FiTruck />}
            onClick={() => setCustomerPage("activeOrders")}
          />

          <StatCard
            title="Completed Orders"
            value={completedOrders.length}
            icon={<FiPackage />}
            onClick={() => setCustomerPage("completedOrders")}
          />

          <StatCard
            title="Notifications"
            value={notifications.length}
            icon={<FiBell />}
            onClick={() => setCustomerPage("notifications")}
          />

          <StatCard
            title="Pending Orders"
            value={pendingOrders.length}
            icon={<FiClock />}
            onClick={() => setCustomerPage("pendingOrders")}
          />
        </div>
      )}

      {customerPage !== "home" && (
        <div
          style={{
            background:"#ffffff",
            borderRadius:"24px",
            padding:isMobile ? "18px" : "22px",
            border:"1px solid #e5e7eb",
            boxShadow:"0 10px 28px rgba(15,23,42,0.06)",
            marginBottom:"20px"
          }}
        >
          <button
            type="button"
            onClick={() => setCustomerPage("home")}
            style={{
              border:"none",
              borderRadius:"12px",
              padding:"10px 14px",
              background:"#f1f5f9",
              color:"#0f172a",
              fontWeight:"900",
              cursor:"pointer",
              marginBottom:"16px"
            }}
          >
            ← Back
          </button>

          <h2
            style={{
              marginTop:0,
              color:"#0f172a",
              fontWeight:"900"
            }}
          >
            {getPageTitle()}
          </h2>

          {customerPage === "notifications" ? (
            notifications.length === 0 ? (
              <EmptyBox text="No notifications found." />
            ) : (
              notifications.map((note,index)=>(
                <InfoCard key={note.id || index}>
                  <strong>
                    {note.title || "Notification"}
                  </strong>
                  <br />
                  {note.message || note.text || "No message"}
                </InfoCard>
              ))
            )
          ) : (
            getPageOrders().length === 0 ? (
              <EmptyBox text="No records found here." />
            ) : (
              getPageOrders().map((o)=>(
                <OrderListCard
                  key={o._id}
                  order={o}
                />
              ))
            )
          )}
        </div>
      )}

      {customerPage === "home" && (
        <div
          style={{
            display:"grid",
            gridTemplateColumns:isMobile ? "1fr" : "1.4fr 0.9fr",
            gap:"22px"
          }}
        >
          <div
            style={{
              background:"#ffffff",
              borderRadius:"24px",
              padding:isMobile ? "18px" : "24px",
              boxShadow:"0 10px 30px rgba(15,23,42,0.06)",
              border:"1px solid #eef2f7"
            }}
          >
            <h3
              style={{
                fontSize:isMobile ? "18px" : "20px",
                fontWeight:"900",
                color:"#0f172a",
                margin:"0 0 16px",
                display:"flex",
                alignItems:"center",
                gap:"10px"
              }}
            >
              <span
                style={{
                  width:"38px",
                  height:"38px",
                  borderRadius:"14px",
                  display:"inline-flex",
                  alignItems:"center",
                  justifyContent:"center",
                  background:"linear-gradient(135deg,#0f172a,#1d4ed8)",
                  color:"#facc15",
                  flexShrink:0
                }}
              >
                <FiTruck />
              </span>
              Recent Delivery Activity
            </h3>

            {orders.length === 0 ? (
              <EmptyBox text="No recent delivery yet. Create your first order." />
            ) : (
              orders.slice(0,3).map((o)=>(
                <OrderListCard
                  key={o._id}
                  order={o}
                />
              ))
            )}

            <button
              type="button"
              onClick={() => setActiveSection("orders")}
              style={{
                marginTop:"8px",
                width:"100%",
                border:"none",
                borderRadius:"14px",
                padding:"10px 14px",
                background:"#2563eb",
                color:"white",
                fontWeight:"900",
                cursor:"pointer"
              }}
            >
              View All Orders
            </button>
          </div>

         
        </div>
      )}

{/* CUSTOMER CHATBOT */}
<button
  type="button"
  onClick={()=>setChatbotOpen(!chatbotOpen)}
  style={{
    position:"fixed",
    right:"22px",
    bottom:"22px",
    width:"58px",
    height:"58px",
    borderRadius:"50%",
    border:"none",
    background:"#1d4ed8",
    color:"white",
    fontSize:"26px",
    fontWeight:"900",
    cursor:"pointer",
    zIndex:9999,
    boxShadow:"0 12px 30px rgba(29,78,216,0.35)"
  }}
>
  <FiMessageCircle />
</button>

{chatbotOpen && (
  <div
    style={{
      position:"fixed",
      right:"22px",
      bottom:"90px",
      width:"320px",
      maxWidth:"calc(100vw - 32px)",
      background:"#ffffff",
      borderRadius:"22px",
      boxShadow:"0 20px 60px rgba(15,23,42,0.25)",
      border:"1px solid #e5e7eb",
      overflow:"hidden",
      zIndex:9999
    }}
  >
    <div
      style={{
        background:"linear-gradient(135deg,#0f172a,#1d4ed8)",
        color:"#facc15",
        padding:"14px",
        fontWeight:"900"
      }}
    >
      MB Swift Assistant
    </div>

    <div
      style={{
        padding:"14px",
        height:"260px",
        overflowY:"auto",
        background:"#f8fafc"
      }}
    >
      {chatbotMessages.map((msg,index)=>(
        <div
          key={index}
          style={{
            display:"flex",
            justifyContent:
              msg.sender === "user"
              ? "flex-end"
              : "flex-start",
            marginBottom:"10px"
          }}
        >
          <div
            style={{
              maxWidth:"80%",
              padding:"10px 12px",
              borderRadius:"14px",
              background:
                msg.sender === "user"
                ? "#1d4ed8"
                : "#facc15",
              color:
                msg.sender === "user"
                ? "white"
                : "#0f172a",
              fontSize:"13px",
              fontWeight:"800",
              lineHeight:"1.4"
            }}
          >
            {msg.text}
          </div>
        </div>
      ))}
    </div>

    <div
      style={{
        display:"flex",
        gap:"8px",
        padding:"12px",
        borderTop:"1px solid #e5e7eb"
      }}
    >
      <input
        value={chatbotText}
        onChange={(e)=>setChatbotText(e.target.value)}
        onKeyDown={(e)=>{
          if(e.key === "Enter"){
            sendChatbotMessage();
          }
        }}
        placeholder="Ask something..."
        style={{
          flex:1,
          border:"1px solid #cbd5e1",
          borderRadius:"14px",
          padding:"11px",
          outline:"none",
          fontWeight:"700"
        }}
      />

      <button
        type="button"
        onClick={sendChatbotMessage}
        style={{
          border:"none",
          borderRadius:"14px",
          padding:"0 14px",
          background:"#facc15",
          color:"#0f172a",
          fontWeight:"900",
          cursor:"pointer"
        }}
      >
        Send
      </button>
    </div>
  </div>
)}

    </>
  );
}

function StatCard({title,value,icon,onClick}) {

  const isMobile =
    window.innerWidth <= 768;

  return (
    <div
      onClick={onClick}
      style={{
        background:"white",
        borderRadius:"18px",
        padding:isMobile ? "16px" : "18px",
        boxShadow:"0 8px 20px rgba(15,23,42,0.06)",
        border:"1px solid #eef2f7",
        minHeight:isMobile ? "120px" : "130px",
        cursor:"pointer",
        transition:"0.25s ease"
      }}
      onMouseEnter={(e)=>{
        e.currentTarget.style.transform =
          "translateY(-3px)";
      }}
      onMouseLeave={(e)=>{
        e.currentTarget.style.transform =
          "translateY(0)";
      }}
    >
      <div
        style={{
          width:"38px",
          height:"38px",
          borderRadius:"14px",
          display:"flex",
          alignItems:"center",
          justifyContent:"center",
          background:"#eff6ff",
          color:"#2563eb",
          fontSize:"18px",
          marginBottom:"12px"
        }}
      >
        {icon}
      </div>

      <div
        style={{
          color:"#64748b",
          fontSize:isMobile ? "13px" : "14px",
          fontWeight:"900",
          marginBottom:"8px"
        }}
      >
        {title}
      </div>

      <div
        style={{
          fontSize:isMobile ? "26px" : "28px",
          fontWeight:"900",
          color:"#0f172a"
        }}
      >
        {value}
      </div>
    </div>
  );
}

function OrderListCard({order}) {
  return (
    <div
      style={{
        padding:"16px",
        borderRadius:"18px",
        background:"#f8fafc",
        border:"1px solid #e5e7eb",
        marginBottom:"12px"
      }}
    >
      <div
        style={{
          background:"#eff6ff",
          border:"1px solid #dbeafe",
          borderRadius:"14px",
          padding:"12px",
          color:"#0f172a",
          fontWeight:"800",
          marginBottom:"10px",
          overflowWrap:"anywhere"
        }}
      >
        <strong style={{color:"#1d4ed8"}}>Route:</strong>{" "}
        {order.pickupLocation} → {order.dropoffLocation}
      </div>

      <div
        style={{
          color:"#0f172a",
          fontWeight:"800",
          marginBottom:"10px"
        }}
      >
        <strong style={{color:"#ca8a04"}}>Amount:</strong>{" "}
        ₵{order.total}
      </div>

      <div
        style={{
          color:"#475569",
          fontWeight:"800",
          fontSize:"13px",
          lineHeight:"1.7"
        }}
      >
        <strong>Status:</strong> {order.status || "N/A"}
        <br />
        <strong>Rider:</strong> {order.rider?.name || "Searching for rider"}
        <br />
        <strong>Motor Name:</strong> {order.rider?.motorName || "Not added"}
        <br />
        <strong>Motor Color:</strong> {order.rider?.motorColor || "Not added"}
        <br />
        <strong>Motor Number:</strong> {order.rider?.motorNumber || "Not added"}
      </div>
    </div>
  );
}

function EmptyBox({text}) {
  return (
    <div
      style={{
        background:"#f8fafc",
        padding:"24px",
        borderRadius:"18px",
        textAlign:"center",
        color:"#64748b",
        fontWeight:"800"
      }}
    >
      {text}
    </div>
  );
}

function InfoCard({children}) {
  return (
    <div
      style={{
        background:"#f8fafc",
        border:"1px solid #e5e7eb",
        borderRadius:"16px",
        padding:"14px",
        marginBottom:"10px",
        color:"#0f172a",
        fontWeight:"700"
      }}
    >
      {children}
    </div>
  );
}

function InfoRow({title,text}) {
  return (
    <div
      style={{
        background:"rgba(255,255,255,0.12)",
        border:"1px solid rgba(255,255,255,0.18)",
        borderRadius:"16px",
        padding:"14px",
        color:"rgba(255,255,255,0.92)",
        fontWeight:"700",
        marginBottom:"8px"
      }}
    >
      <strong style={{color:"#facc15"}}>
        {title}
      </strong>{" "}
      {text}
    </div>
  );
}